export default "__VITE_ASSET__Bx3V2EH6__"